import React from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import {useTranslation} from "react-i18next";

import useVonAuthentication from '../../Hooks/useVonAuthentication';
import commonActionsImp from '../../Actions/commonActions';

import './VonAuthorization.css';

const VonAuthorization = ({ onCancel, redirectUrl, children }) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const isSignedIn = useVonAuthentication();

    const commonActions = bindActionCreators(commonActionsImp, dispatch);

    if (!isSignedIn) {
        return (
            <div className="von-authorization-prompt position-absolute-center text-center">
                <div className="auth-content">
                    <p>{t('vonAuthorization.message')}</p>

                    <button className="btn btn-primary" onClick={() => commonActions.signInToVon(redirectUrl)}>
                        {t('vonAuthorization.confirmAction')}
                    </button>
                    
                    {onCancel && (
                        <button className="btn btn-default" onClick={onCancel}>
                            {t('vonAuthorization.cancelAction')}
                        </button>
                    )}
                </div>
            </div>
        );
    }

    return <>{children}</>;
};

export default VonAuthorization;
